import { render } from "./SkillPreview.vue?vue&type=template&id=d10c6492&scoped=true"
import script from "./SkillPreview.vue?vue&type=script&lang=js"
export * from "./SkillPreview.vue?vue&type=script&lang=js"

import "./SkillPreview.vue?vue&type=style&index=0&id=d10c6492&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d10c6492"

export default script